import shell from './shell.htm';
import shellCss from './shell.css';

const headStyleTagsId = 'c058b-065d-4432-ae8c-32f85b1e366f';
const replaceId = 'da1f1ec-e48b-4498-b30c-815b95345ddb';
const headStyleTags = `
<style id="${headStyleTagsId}">
 ${shellCss}
</style>
`;

class ElementBoxSelector {
  constructor({
    onAttach
  }) {
    this.onAttach = typeof(onAttach) === 'function' ? onAttach : false;
    this.dom = {
      lastModified: null,
      shell: null,
    }

    this.dom.shell = document.createElement('div');
    this.dom.shell.innerHTML = shell;
  }

  cleanup() {
    this.unselect();
  }

  getContentElement() {
    return this.dom.lastModified;
  }

  attachHeadStyles(documentHead) {
    documentHead.insertAdjacentHTML('beforeend', headStyleTags);
  }

  contains(element) {
    return this.dom.shell.contains(element);
  }

  unselect() {
    this.dom.shell.replaceWith(this.dom.lastModified);
    this.dom.lastModified = null;
  }

  attachToElement(element) {
    if(this.dom.shell.contains(element)) {
      console.warn('can not edit child of shell');
      return;
    };
    if(this.dom.lastModified === element) {
      console.warn('can not edit same element');
      return;
    }
    if(this.dom.shell === element) {
      console.warn('can not edit shell');
      return;
    }

    if(this.dom.lastModified) this.unselect();

    this.dom.lastModified = element;
    const replaceMe = this.dom.shell.querySelector(`#${replaceId}`);
    element.replaceWith(this.dom.shell);
    replaceMe.innerHTML = '';
    replaceMe.appendChild(element);
    
    if(this.onAttach) {
      this.onAttach(element);
    }
  }

  getData() {
    return {
      dom: { ...this.dom },
    }
  }

}

export default ElementBoxSelector;